import styled from 'styled-components'
import { SPACING } from '../../../../../styles/theme'

/**
 * Styled components for inline styles in ReportSidebar
 */

// Text with top margin for empty states
export const EmptyStateText = styled.span`
  margin-top: ${SPACING.lg};
`
